import { useEffect } from 'react';
import { useNavigate } from 'react-router';

export function CampaignRedirect() {
  const navigate = useNavigate();
  useEffect(() => { navigate('/leads', { replace: true }); }, [navigate]);
  return null;
}
